import {global} from './ApiGlobal';
import {user} from './ApiUser';
import {hris} from './ApiHRIS';
import {company} from './ApiCompany';
import {superAdmin} from './ApiSuperAdmin';
import {storage} from './storage/ApiStorage';
import {event} from './ApiEvent';
import {draft} from './ApiDraft';
import {invitedUsers} from './collections/ApiInvitedUsers';
import {interests} from './collections/ApiInterests';
import {interestAnalytics} from './ApiInterestAnalytics';
import {hubbl} from './ApiHubbl';
import {breaks} from './ApiBreak';
import {generalSettings} from './ApiGeneralSettings';
import {admin} from './ApiAdmin';
import {ApiCalendar} from './ApiCalendar';
import {questionBank} from './ApiQuestionBank';
import type {UpdateEventDetailsProps} from './ApiEvent';

export const Api = {
  global,
  event,
  draft,
  user,
  hris,
  storage,
  company,
  superAdmin,
  invitedUsers,
  interests,
  interestAnalytics,
  hubbl,
  breaks,
  generalSettings,
  admin,
  calendar: ApiCalendar,
  questionBank,
};
export type {UpdateEventDetailsProps};
